export var StencilOperation;
(function (StencilOperation) {
    StencilOperation[StencilOperation["Keep"] = 0] = "Keep";
    StencilOperation[StencilOperation["Zero"] = 1] = "Zero";
    StencilOperation[StencilOperation["Replace"] = 2] = "Replace";
    StencilOperation[StencilOperation["IncrementSaturate"] = 3] = "IncrementSaturate";
    StencilOperation[StencilOperation["DecrementSaturate"] = 4] = "DecrementSaturate";
    StencilOperation[StencilOperation["Invert"] = 5] = "Invert";
    StencilOperation[StencilOperation["IncrementWrap"] = 6] = "IncrementWrap";
    StencilOperation[StencilOperation["DecrementWrap"] = 7] = "DecrementWrap";
})(StencilOperation || (StencilOperation = {}));
